<template>
  <div id="main">
    <nav v-bind:class="active" v-on:click.prevent>
      <a href="#" class="home" v-on:click="makeActive('home')">Home</a>
      <a href="#" class="aboutus" v-on:click="makeActive('aboutus')">About Us</a>
      <a href="#" class="contacts" v-on:click="makeActive('contacts')">Contact Information</a>
      <a href="#" class="links" v-on:click="makeActive('links')">Links</a>
      <a href="#" class="rules" v-on:click="makeActive('rules')">Trail Ride Rules</a>
      <a href="#" class="registration" v-on:click="makeActive('registration')">Member Registration</a>
      <a href="#" class="calendar" v-on:click="makeActive('calendar')">Calendar</a>
      <a href="#" class="newsletters" v-on:click="makeActive('newsletters')">Newsletters</a>
    </nav>
  </div>
</template>

<script>
  import router from '../router';
    export default {
        name: "menupicker",
        data () {
          return {
            active: 'home'
          }
        },
      props: ['value'],
      methods: {
        makeActive: function(item){
          this.active=item;
          router.push({ path: item} );
        },
        setActive: function(item) {
          this.active=item;
        }
      },
      mounted() {
          this.setActive(this.value);

      }
    }
</script>

<style scoped>

  nav{
    display:inline-block;
    margin:1vw auto 1vh;
    background-color:#5597b4;
    box-shadow:0 1px 1px #ccc;
    border-radius:2px;
    width: 95vw;
  }

  nav a{
    display:inline-block;
    padding: 1vw 1vw;
    color:#fff !important;
    font-weight:bold;
    font-size: 1.25vw;
    text-decoration:none !important;
    line-height:1;
    text-transform: uppercase;
    background-color:transparent;

    -webkit-transition:background-color 0.25s;
    -moz-transition:background-color 0.25s;
    transition:background-color 0.25s;
  }

  nav a:first-child{
    border-radius:2px 0 0 2px;
  }

  nav a:last-child{
    border-radius:0 2px 2px 0;
  }

  nav.home .home,
  nav.aboutus .aboutus,
  nav.contacts .contacts,
  nav.links .links,
  nav.rules .rules,
  nav.registration .registration,
  nav.calendar .calendar,
  nav.newsletters .newsletters{
    background-color:#e35885;
  }
</style>



// WEBPACK FOOTER //
// src/components/MenuPicker.vue